import type { NetworkType, ParamTreeNode } from '@mls-wallet/shared-types';
import type { AddressBookExactEntry } from '@/types/address-book';
import { AddressDisplay } from '@/components/shared/address-display';

/**
 * Display an address parameter
 */
export function RawValueAddress(props: {
  paramTreeNode: ParamTreeNode;
  networkId: NetworkType;
  depth: number;
  inListOrObject?: boolean;
  addressBookEntryByAddress?: Map<string, AddressBookExactEntry>;
}) {
  const rawAddress = props.paramTreeNode.rawValue;

  // Case: address is missing or invalid
  if (typeof rawAddress !== 'string' || rawAddress === '') {
    return <span>Undecodable Address</span>;
  }

  const address = rawAddress;
  const entry = props.addressBookEntryByAddress?.get(address.toLowerCase());
  const label = entry?.name?.trim() || undefined;

  const addressDisplay = (
    <AddressDisplay
      address={address}
      name={label}
      showAddressName
      truncateAddress={false}
      addressNameLayout={
        props.inListOrObject && props.depth > 1 ? 'inline' : 'stacked'
      }
      className="text-sm"
    />
  );

  // Case: nested in list/object, render inline
  if (props.inListOrObject && props.depth > 1) return addressDisplay;

  // Case: root level, wrap with border
  return (
    <div className="px-3 py-2 border border-zinc-200 border-l-2 border-l-zinc-900 bg-zinc-50 rounded-sm">
      {addressDisplay}
    </div>
  );
}
